import { CartItemProps } from "../types";
import { useProductTranslations } from "../../../hooks/TranslationHooks";
import { Input } from "reactstrap";
import classNames from "classnames";
import FormattedPrice from "../../FormattedPrice";
import { multiply } from "../../../utils/NumberUtils";
import { productIsPerSquareMeter } from "../../../utils/ProductUtils";
import Icon from "../../Icon";
import ConditionalLink from "../../ConditionalLink/ConditionalLink";

const CompactCartItem = ({
  to,
  previewImage,
  productName,
  productSku,
  amount,
  updateAmount,
  removeFromCart,
  currency,
  price,
  /*total,
  unitPrice,
  stockStatus,*/
  priceUnit,
  unitQuantityFactor,
  availableStock = 0,
  isSample = false,
  b2b = false
}: CartItemProps) => {
  const tp = useProductTranslations();
  const isPerSquareMeter = productIsPerSquareMeter(unitQuantityFactor);
  return (
    <li className={classNames("cart-item", { b2b: b2b })} data-sku={productSku}>
      <div className={"image-column"}>
        <ConditionalLink to={to}>
          <img className={"w-100"} src={previewImage} alt={"Product"} />
        </ConditionalLink>
      </div>
      <div className={"content-columns"}>
        <div className={"padded-column info-column"}>
          <ConditionalLink to={to} className={"text-black"}>
            <h4>
              {b2b && <span className="text-pale">{productSku} </span>}
              {isSample && tp("sample") + ": "}
              {productName}
            </h4>
          </ConditionalLink>
        </div>
        <div className={"padded-column amount-column"}>
          <div className="amount-cell">
            {!isSample && (
              <>
                <Input
                  type={"number"}
                  value={amount}
                  onChange={updateAmount}
                  max={availableStock || 999}
                  aria-label={tp("sales_unit." + priceUnit)}
                />
                <span className="text-small">
                  {tp("sales_unit." + priceUnit)}
                </span>
                {isPerSquareMeter && (
                  <>
                    {" ("}
                    {multiply(unitQuantityFactor, amount)}
                    &nbsp;m&sup2;
                    {")"}
                  </>
                )}
              </>
            )}
          </div>
        </div>

        <div className={"padded-column total-column"}>
          <div className={"text-end"}>
            <FormattedPrice
              bold_price={true}
              price={multiply(price, amount)}
              currency={currency}
            />
          </div>
        </div>
      </div>
      <div className={"icons"}>
        <button
          className={"btn btn-remove"}
          onClick={e => {
            e.stopPropagation();
            removeFromCart();
          }}
        >
          <Icon name="trash" />
        </button>
      </div>
    </li>
  );
};

export default CompactCartItem;
